module.exports = __webpack_public_path__ + "img/up.a48f80d7.svg";